"use client";

import * as React from "react";
import { cn } from "../lib/utils";

export interface NavbarProps extends React.HTMLAttributes<HTMLElement> {
  brand?: React.ReactNode;
  left?: React.ReactNode;
  right?: React.ReactNode;
}

export function Navbar({
  brand,
  left,
  right,
  className,
  ...props
}: NavbarProps) {
  return (
    <nav
      className={cn(
        "sticky top-0 z-50 bg-white border-b border-gray-200 shadow-sm",
        className,
      )}
      {...props}
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex h-16 items-center justify-between">
          <div className="flex items-center gap-4">
            {brand ?? (
              <a
                href="/"
                className="font-heading text-2xl font-bold text-brand-500"
              >
                Echt Grandios
              </a>
            )}
            {left}
          </div>
          <div className="flex items-center gap-2">{right}</div>
        </div>
      </div>
    </nav>
  );
}
